import { render, staticRenderFns } from "./charmRiskRegister.vue?vue&type=template&id=91843c54"
import script from "./charmRiskRegister.vue?vue&type=script&lang=js"
export * from "./charmRiskRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91843c54')) {
      api.createRecord('91843c54', component.options)
    } else {
      api.reload('91843c54', component.options)
    }
    module.hot.accept("./charmRiskRegister.vue?vue&type=template&id=91843c54", function () {
      api.rerender('91843c54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/charm/risk/charmRiskRegister.vue"
export default component.exports